import { POSTWithAuthNoResponse } from './Index'

import { VerifyTwitterRequest } from '../interfaces'

export async function VerifyTwitter(status_id: string): Promise<void> {
  return await POSTWithAuthNoResponse<VerifyTwitterRequest>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/verify/twitter`,
    {
      status_id,
    }
  )
}
